import { TokenInfoResult } from '@varo/graphql-schema-types';
import GetReactivationTokenInfo from 'services/graphql/queries/GetReactivationTokenInfo';
import { AnyVariables, useQuery } from 'urql';

const useReactivateAccount = () => {
  const [{ data, fetching, error }] = useQuery<
    {
      getTokenInfo: TokenInfoResult;
    },
    AnyVariables
  >({
    query: GetReactivationTokenInfo,
    requestPolicy: 'network-only',
  });

  return {
    data,
    fetching,
    error,
  };
};

export default useReactivateAccount;
